document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.video-facade').forEach(facade => {
        const handleActivation = () => {
            const provider = facade.dataset.videoProvider;
            const videoId = facade.dataset.videoId;
            const extraParams = facade.dataset.videoParams || '';

            if (!videoId || !provider) return;

            const iframe = document.createElement('iframe');

            if (provider === 'youtube') {
                const params = extraParams
                    ? `autoplay=1&${extraParams}`
                    : 'autoplay=1&rel=0';
                iframe.src = `https://www.youtube.com/embed/${videoId}?${params}`;
            } else if (provider === 'vimeo') {
                const params = extraParams
                    ? `autoplay=1&${extraParams}`
                    : 'autoplay=1';
                iframe.src = `https://player.vimeo.com/video/${videoId}?${params}`;
            } else {
                return;
            }

            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('allow', 'autoplay; encrypted-media; accelerometer; clipboard-write; gyroscope; picture-in-picture');
            iframe.setAttribute('title', facade.getAttribute('aria-label') || 'Video');
            iframe.classList.add('absolute', 'inset-0', 'w-full', 'h-full');

            facade.innerHTML = '';
            facade.appendChild(iframe);
        };

        facade.addEventListener('click', handleActivation);

        // Keyboard support for Enter and Space
        facade.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleActivation();
            }
        });
    });
});
